export const deviceQuestions = [
  {
    label: { en: 'C2F', fr: 'C2F' },
    key: 'coperToFibreMigration',
    options: [
      { en: 'Yes', fr: 'Oui' },
      { en: 'No', fr: 'Non' }
    ]
  },
  {
    label: { en: 'Segment', fr: 'Segment' },
    key: 'customerSegment',
    options: [
      { en: 'SMB (1-30)', fr: 'SMB (1-30)' },
      { en: 'SMB (30-100)', fr: 'SMB (30-100)' },
      { en: 'Commercial', fr: 'Commercial' }
    ]
  },
  {
    label: { en: 'Term', fr: 'Durée' },
    key: 'contractTerm',
    options: [
      { en: 'Month-to-Month', fr: 'sur une base mensuelle' },
      { en: '3 years', fr: '3 ans' },
      { en: '5 years', fr: '5 ans' }
    ]
  },
  {
    label: { en: 'Version', fr: 'Version' },
    key: 'customerRequireAIFeatures',
    options: [
      { en: 'No', fr: 'Non', displayLabel: { en: 'Version 1', fr: 'Version 1' } },
      { en: 'Yes', fr: 'Oui', displayLabel: { en: 'Version 2', fr: 'Version 2' } }
    ]
  },
  {
    label: { en: 'Type of Installation', fr: "Type d'installation" },
    key: 'typeOfInstallation',
    options: [
      { en: 'New', fr: 'Nouveau' },
      { en: 'Add On', fr: 'Ajouter' }
    ]
  },
  {
    label: { en: 'Business Connect Edition', fr: "Version de Connexion Affaires" },
    key: 'businessConnectEdition',
    options: [
      { en: 'Voice +', fr: 'Voix PLUS' },
      { en: 'Enhanced', fr: 'Amélioré' },
      { en: 'Complete', fr: 'Complet' },
      { en: 'Complete +', fr: 'Complet PLUS' },
      { en: 'Mobile', fr: 'Mobile' },
      { en: 'Voice', fr: 'Voix' }
    ]
  },
  {
    label: { en: 'Bundled', fr: 'Groupé' },
    key: 'otherTelusServices',
    options: [
      { en: 'Yes', fr: 'Oui' },
      { en: 'No', fr: 'Non' }
    ]
  },
  {
    label: { en: 'Spare Devices', fr: 'D’appareils additionnels' },
    key: 'doesCustomerRequireSpareDevices',
    options: [
      { en: 'Yes', fr: 'Oui' },
      { en: 'No', fr: 'Non' }
    ]
  },
  {
    label: { en: 'Hardware Credit', fr: 'Crédit matériel' },
    key: 'hardwareCredir',
    options: [
      { en: 'Yes', fr: 'Oui' },
      { en: 'No', fr: 'Non' }
    ]
  }
];

export const DEVICES_PER_PAGE = 30;
